import React from 'react';
import styled from 'styled-components';
import moment from 'moment/moment';

import useUser from 'core/hooks/useUser';
import { Box, Text } from 'core/ui/atoms';

const DeliveryDay = () => {
  const { currentUser } = useUser();
  const nextCutoffTime = moment(currentUser?.nextDeliveryOrderDate).format('dddd, MMMM Do');

  if (!currentUser?.nextDeliveryOrderDate) {
    return null;
  }

  return (
    <Container>
      <TextBox>Your next box will be delivered</TextBox>
      <TextBox>between 8AM-8PM on {nextCutoffTime}</TextBox>
    </Container>
  );
};

const Container = styled(Box)`
  background: ${({ theme }) => theme.colors.primary};
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
`;

const TextBox = styled(Text)`
  color: ${({ theme }) => theme.colors.creamWhite};
  font-family: ${({ theme }) => theme.typography.familyPopins};
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  padding: 12px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
`;

export default DeliveryDay;
